<template>
    <div>
        <el-form class="form" ref="form" label-width="80px">
            <el-checkbox class="checkbox" v-model="checked"></el-checkbox>
            <el-form-item label="位置" style="margin-bottom:12px;">
                <el-radio-group v-model="data">
                    <el-radio :label="0">上</el-radio>
                    <el-radio :label="1">下</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
export default {
    name: 'Position',
    props: {
        value: Object
    },
    watch: {
        checked(newVal, oldVal) {
            this.submit()
        },
        data(newVal, oldVal) {
            this.submit()
        },
    },
    data() {
        return {
            type: 'Position',
            checked: false,
            data: 0,
        }
    },
    created() {},
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.checked = this.value.checked
            this.data = this.value.value
            if (this.data == null) {
                this.data = 0
            } else {
                this.data = parseInt(this.data)
            }
        },
        submit() {
            var data = {
                type: this.type,
                checked: this.checked,
                value: this.data
            }
            this.$emit('input', data)
        },
    },
}
</script>
<style lang="scss">
.form {
    display: flex;
    align-items: center;
}
</style>